// Sections own half the space between them, so two neighbours at "normal" sit
// 128 apart. A block that needs more air steps up a level instead of hardcoding
// a number its neighbour would have to know about.
export const SPACE_BELOW = {
  normal: "md:mb-16",
  loose: "md:mb-32",
  looser: "md:mb-48",
} as const;

export type SpaceBelow = keyof typeof SPACE_BELOW;
